"use strict";

/**
 * Stores quote data that can be used to:
 *    - Display summary of quote
 *    - Transform data for posting requests
 *    - Transform data for responses
 *
 * @param {UserInputRepository} userInputRepository                        Passed in from services/config.js
 * @param {ServiceResponseRepository} serviceResponseRepository            Passed in from services/config.js
 * @param {Util} Util                                                    Passed in from services/config.js
 * @constructor
 */
function CaravanQuoteModel(MODULE_INFO, userInputRepository, serviceResponseRepository, quoteOptions, quoteRequestRepository, Util) {
	var self = this;

	var selectedQuote= quoteOptions.getSelectedQuoteResult() ;
	var selectedQuoteForPayment = quoteOptions.getSelectedQuoteResultForPayment() ;
	// cover type
	this.selectedQuote = selectedQuote;
	this.selectedQuoteForPayment = selectedQuoteForPayment;
	/**
	 * Retrieves values from UserInputRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from UserInputRepository to return
	 * @private
	 */
	this._getUserInputValueFor = function (dotSeperatedFieldPath) {
		var userInput = userInputRepository.get();
		return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');
	}

	/**
	 * Retrieves values from ServiceResponseRepository
	 * @param {String} dotSeperatedFieldPath                    Path to value to retrieve
	 * @return {*}                                                Value from ServiceResponseRepository to return
	 * @private
	 */
	this._getServiceResponseValueFor = function (serviceName, dotSeperatedFieldPath) {
		return serviceResponseRepository.getLastResponseFrom(serviceName);
	}

	/**
	 * Calculates whether at least one driver in the last 4 years, has been charged or convicted of any driving offences
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_licenceRSDC = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_licenceRSDC) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {
			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_chargedOrConvictedOffences) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_fourYears_vehicleAccidentsClaims = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.fourYears_vehicleAccidentsClaims) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}
	/**
	 *
	 * @returns {boolean}
	 * @private
	 */
	this._driversHave_tenYears_chargedOrConvictedOffences = function () {
		if (this.drivers) {

			var driversLength = this.drivers.length,
				atLeastOneDriverHas = false,
				driver;

			for (var i = 0; i < driversLength; i++) {
				driver = this.drivers[i];

				if (driver.tenYears_chargedOrConvictedOffences) {
					atLeastOneDriverHas = true;
					break;
				}
			}

			return atLeastOneDriverHas;
		}
	}

	this.email = this._getUserInputValueFor('caravanForm.tellUsABitMore.yourEmailAddress')?this._getUserInputValueFor('caravanForm.tellUsABitMore.yourEmailAddress'):this._getUserInputValueFor('email');

	// vehicle form data
	this.caravanForm = this._getUserInputValueFor('caravanForm');

	// rego details
	this.regoDetails = this._getServiceResponseValueFor('regoSearch');

	if ( selectedQuoteForPayment ) {
		this.vehicleInfo = selectedQuoteForPayment.response.caravans[0].caravanInfo;
	}

	// vehicle type
	this.vehicleType = this._getUserInputValueFor('caravanForm.aboutYourCaravan.vehicleType');

	// vehicle agreed value
	this.agreedValue = this._getUserInputValueFor('caravanForm.sumInsured.agreedValue');
	this.generalContentsValue = this._getUserInputValueFor('caravanForm.aboutYourContents.generalContentsValue') ;
	this.specifiedContentItems = this._getUserInputValueFor('caravanForm.aboutYourContents.contentsItems') || [] ;
	this.totalSpecifiedContentValue = function(items) {
		var total = 0 ;
		angular.forEach(items, function(item) { total += item.value ; });
		return total ;
	}(this.specifiedContentItems);

	this.totalContentsValue = this.totalSpecifiedContentValue + this.generalContentsValue ;

	this.annexeCost = this._getUserInputValueFor('caravanForm.sumInsured.annexeReplacementCost');
	this.sumInsured = this.agreedValue + this.annexeCost;

	this.contentsSumInsured = 1000; // TODO: Aggregate the contents items + general contents value

	this.purchaseMonth = this._getUserInputValueFor('caravanForm.caravanDetails.whenDidYouBuyMonth');
	this.purchaseYear = this._getUserInputValueFor('caravanForm.caravanDetails.whenDidYouBuyYear');
	this.purchaseDate = this.purchaseMonth + '/' + this.purchaseYear;

	this.isCaravanRegistered = this._getUserInputValueFor('caravanForm.caravanDetails.isCaravanRegistered');

	if ( this.isCaravanRegistered ) {
		this.regoNumber = this._getUserInputValueFor('caravanForm.caravanDetails.regoNumber');
	}

	if ( this.regoDetails ) {
		this.vehicleOptionalEquipments = this.regoDetails.optionalEquipments ;
	}else if(this.caravanForm && this.caravanForm.caravanInfo){
		this.regoDetails = this.caravanForm.caravanInfo;
	}

	this.showLayupDiscount = (this.vehicleType == 'caravan' || this.vehicleType == 'campertrailer' || this.vehicleType == 'slideoncamper' || this.vehicleType == 'motorhome' || this.vehicleType == 'campervan') && this.isCaravanRegistered;

	this.showOnsiteDiscount = (this.vehicleType == 'caravan' || this.vehicleType == 'campertrailer' || this.vehicleType == 'slideoncamper' || this.vehicleType == 'motorhome' || this.vehicleType == 'campervan') && !this.isCaravanRegistered;


	//  this._getServiceResponseValueFor('quickQuote');
	if (selectedQuote ) {
		this.annualCoverType = selectedQuote.getAnnual();
		this.monthlyCoverType = selectedQuote.getMonthly();
		this.quoteResult = selectedQuoteForPayment ;
		if ( this.quoteResult ) {
			this.coverageOptions = this.quoteResult.coverageOptions ;
			if ( this.coverageOptions ) {
				this.coverageOptionsToShow = this.coverageOptions.filter(function(op) {
					return op.required === false && op.name !== 'QPCLayupCover' ;
				});
				this.hasCoverageOptions = this.coverageOptionsToShow.length > 0 ;
			}
			this.excess = this.quoteResult.excess ;
			this.namedDriverExcess = findNamedDriverExcess() ;
			this.excludedDrivers = findExcludedDrivers();
		}
	}

	function findNamedDriverExcess() {
		var namedDriverExcess = [],
			qr = selectedQuoteForPayment ? selectedQuoteForPayment.response : null ;

		if ( qr && qr.caravans ) {
			var drivers = qr.caravans[0].drivers ;
		 	drivers.forEach( function(driver) {
		 		if ( driver.driver
		 			&& driver.driver.calculatedExcess
		 			&& driver.driver.calculatedExcess > 0 ) {
		 				namedDriverExcess.push({
		 					firstName : driver.driver.person.firstName,
		 					lastName: driver.driver.person.lastName,
		 					excessValue : driver.driver.calculatedExcess,
							dob: driver.driver.dateOfBirth
		 				});
		 		}
		 	});
		}

	 	return namedDriverExcess ;
	}

	/**
	* Excluded drivers
	*/
	function findExcludedDrivers() {
		var excludedDrivers = [] ;
		if (selectedQuoteForPayment ) {
			var quote = selectedQuoteForPayment.response ;
			quote.caravans[0].drivers.forEach(function(driver) {
				if ( driver.driverUsage == 'excluded')
					excludedDrivers.push(driver.driver.person) ;
			})	;
		}

		return excludedDrivers
	}

	this.hasExcludedDrivers = function() {
		return this.excludedDrivers && this.excludedDrivers.length > 0 ;
	}

	/** excess list to be displayed in the quote panel */
	this.displayableExcessList = null;

	this.getDisplayableExcess=function() {
		if ( ! this.excess )
			return [] ;

		if ( ! this.displayableExcessList) {
			var filterOut =  ['voluntaryVehicleExcessOptions', 'voluntaryVehicleExcess', 'standardVehicleExcess'] ;
			this.displayableExcessList = [] ;

			for ( var key in this.excess) {
				if ( filterOut.indexOf(key) === -1)
					this.displayableExcessList.push({ key : key, excessValue : this.excess[key] }) ;
			}
		}

		return this.displayableExcessList ;
	}



	this.drivers = [];
	this.postCode = null;
	this.campaignCode = null ;
	if (this.caravanForm) {
		//TODO: set regoNumber based on step 1 or step 4

		// vehicleDetails
		if (this.caravanForm.caravanDetails) {
			this.primaryUse = this.caravanForm.caravanDetails.primaryUse;
			switch (this.primaryUse) {
				case 'commercial':
					this.primaryUse += ' - ' + this.caravanForm.caravanDetails.commercialActivityType.label;
					break;
				case 'business':
					this.primaryUse += ' - ' + this.caravanForm.caravanDetails.businessActivityType.label;
					break;
			}
		}

		if ( this.caravanForm.getStarted) {
			this.personOrCompany = this.caravanForm.getStarted.personOrCompany;
			this.policyStartDate = this.caravanForm.getStarted.policyStartDate;
		}

		// Main drivers & additional drivers
		this.additionalDrivers = [];

		if (this.caravanForm.driver) {
     		var drivers=this.caravanForm.driver.drivers;
     		if(drivers){

				this.mainDriver = drivers[0];

      			if(drivers.length>1){
         			this.additionalDrivers=drivers.splice(1,drivers.length);
      			}
     		}
		}

		// drivers
		if (this.mainDriver) {
			this.drivers = [this.mainDriver];
		}
		if (this.additionalDrivers) {
			this.drivers = this.drivers.concat(this.additionalDrivers);
		}

		// address
		var aboutYourCaravan = this.caravanForm.aboutYourCaravan ;
		if ( aboutYourCaravan) {
			if (aboutYourCaravan.address ) {
				this.address = aboutYourCaravan.address	;
				this.postCode = this.address.postalCode;
				this.state = this.address.state.replace('AU_', '') ;
			}
			this.searchType = aboutYourCaravan.searchType;

			if ( this.searchType == 'manually') {
				var year = aboutYourCaravan.year,
					make = aboutYourCaravan.make,
					model = aboutYourCaravan.model,
					bodyType = aboutYourCaravan.bodyType,
					berths = aboutYourCaravan.berths,
					weight = aboutYourCaravan.weight,
					caravanLength = aboutYourCaravan.manualLength,
					lengthUnits = aboutYourCaravan.manualLengthUnits,
					customBuilt = aboutYourCaravan.customBuilt;

				this.yearMakeModel = year + ', ' + make + ', ' + model+ ', ' + bodyType + ', ' + berths + ', ' + weight + ', ' + caravanLength + lengthUnits;
			} else if (this.regoDetails) {
				var year = this.regoDetails.modelYear,
					make = this.regoDetails.make,
					model = this.regoDetails.model;

				this.yearMakeModel = year + ' ' + make + ' ' + model;
			}
		}

		if ( this.caravanForm.promotionalCode ) {
			this.campaignCode = this.caravanForm.promotionalCode.promotionalCode ;
		}

		if (this.caravanForm.mainPolicyHolderContact) {
			this.mainPolicyHolder = this.caravanForm.mainPolicyHolderContact;
		}

	}


	// this.quoteId = this._getServiceResponseValueFor('service-name', 'quote.quoteId');
	this.quoteId = null ;
	if ( quoteRequestRepository.getSelectedQuoteCredentials() )
		this.quoteId = quoteRequestRepository.getSelectedQuoteCredentials().quoteID ;


	/** Google Tag Manager data **/
	this.gtmPolicyHolder = this.mainDriver ? this.mainDriver.person : null;
	this.gtmTransactionAffiliation = 'QBE Direct' ;
	this.insuranceType =  MODULE_INFO.insuranceType ;
	this.productCode = MODULE_INFO.productCode ;

}
